import { Grid } from "@mui/material";
import arrayMutators from "final-form-arrays";
import React from "react";
import { Form } from "react-final-form";
import { useNavigate } from "react-router";
import Libelle from "../../../_i18n/fr.json";
import CheminDeFer from "../../../components/cheminDeFer/CheminDeFer";
import Layout from "../../../components/Layout";
import LoadingBoundary from "../../../components/LoadingBoundary";
import RenderError from "../../ErrorContainer";
import { construireCommunes } from "../BienPage/helpers";
import {
  getSituationPersonnelleModel,
  SituationPersonnelleForm,
  qualites,
  situationMaritale,
  statutOccupation,
  validateForm,
} from "./helpers";
import { useSituationPersonnelle } from "./selectors";
import SituationPersonnelleFormPage from "./situationPersonnelleForm";

function AjouterSituationPersonnellePage() {
  const {
    typesVoie,
    typeVoieFetching,
    typeVoieError,
    loadTypesVoie,
    chargerCommunes,
    communes,
    dossierLocation,
    dossierLocationRef,
    postError,
    postLoading,
    putError,
    putLoading,
    handleSubmit,
    resetPost,
    resetPut,
    // postErrorSecondaire,
    // postLoadingSecondaire,
    // resetPostSecondaire,
    // putErrorSecondaire,
    // putLoadingSecondaire,
    // resetPutSecondaire,
    initialValues,
    selectedPerson,
  } = useSituationPersonnelle();
  // const { pristine } = useFormState();

  const onSubmit = (situationPersonnelleForm: SituationPersonnelleForm) => {
    const situations =
      dossierLocationRef &&
      getSituationPersonnelleModel(
        situationPersonnelleForm,
        dossierLocationRef
      );
    if (situations) {
      handleSubmit(situations);
    }
  };

  return (
    <React.Fragment>
      <Layout title={Libelle.pageSituationPerso.titre}>
        <CheminDeFer isEtape="situationPersonnelle" />
        <LoadingBoundary
          loading={typeVoieFetching}
          error={typeVoieError}
          onRetry={loadTypesVoie}
        >
          <Form
            keepDirtyOnReinitialize
            name="situationPersonnelleForm"
            initialValues={initialValues as SituationPersonnelleForm}
            validate={(values: SituationPersonnelleForm) =>
              dossierLocation &&
              validateForm(
                values,
                values &&
                  values.compositionLocation === "COUPLE" &&
                  values &&
                  values.typeCompte !== "GARANT"
              )
            }
            onSubmit={onSubmit}
            mutators={{
              ...arrayMutators,
            }}
          >
            {({
              handleSubmit,
              pristine,
              submitting,
              form: {
                mutators: { push, pop },
              },
              errors,
              values,
            }) => (
              <SituationPersonnelleFormPage
                values={values}
                push={push}
                pop={pop}
                onSubmit={handleSubmit}
                listTypeVoie={typesVoie}
                listSituations={situationMaritale}
                statutOccupation={statutOccupation}
                qualites={qualites}
                dossierLocation={dossierLocation}
                onChangeCommune={chargerCommunes}
                selectedPerson={selectedPerson}
                isFetching={
                  putLoading || postLoading
                  // ||
                  // postLoadingSecondaire ||
                  // putLoadingSecondaire
                }
                communes={communes && construireCommunes(communes)}
              />
            )}
          </Form>
          <Grid container justifyContent="flex-end" style={{ marginTop: 12 }}>
            {(putError || postError) && (
              <RenderError
                errors={putError || postError}
                onClose={() => {
                  resetPost();
                  resetPut();
                }}
              />
            )}
          </Grid>
        </LoadingBoundary>
      </Layout>
    </React.Fragment>
  );
}

export default AjouterSituationPersonnellePage;
